import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { workItemRoute } from '@atlassian/jira-router-routes-work-items-routes/src/workItemRoute.tsx';
import { genericProjectSidebars } from '@atlassian/jira-navigation-apps-sidebar-generic-sidebars/src/ui/index.tsx';
import { getNavigationResourcesForWorkItem } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { workItemPageEntrypoint } from './ui/index.tsx';

export const workItemRouteEntry = createEntry(workItemRoute, () => ({
	group: 'work-item',

	navigation: {
		sidebar: genericProjectSidebars,
		menuId: MENU_ID.PROJECTS,
	},
	// bifrost property is set up, which is required for Bifrost SSR onboarding
	bifrost: {
		bifrostGroup: 'issue-view',
		bundling: {
			packageName: '@atlassian/jira-router-routes-work-items-entries/src/workItemRouteEntry.tsx',
			whichExportToUse: 'workItemRouteEntry',
		},
		enabled: true,
		manifestName: 'jira-spa-issue-view.json',
	},
	meta: {
		capability: 'WORK_ITEM_VIEW',
	},
	resources: [...getNavigationResourcesForWorkItem()],

	entryPoint: () => workItemPageEntrypoint,
	ufoName: 'work-item',
	supportsPreviewPanel: true,
}));
